import { render, staticRenderFns } from "./CorporationDoc.vue?vue&type=template&id=a87c4db4&scoped=true&"
import script from "./CorporationDoc.vue?vue&type=script&lang=js&"
export * from "./CorporationDoc.vue?vue&type=script&lang=js&"
import style0 from "./CorporationDoc.vue?vue&type=style&index=0&id=a87c4db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87c4db4",
  null
  
)

export default component.exports